exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".container__l2M6N{width:300px;background-color:#eee;position:relative}.bar__1qLtQ,.container__l2M6N{border-radius:2px;height:16px;max-width:100%}.bar__1qLtQ{background-color:var(--primary-color-500);-webkit-transition:width .2s ease-in-out;transition:width .2s ease-in-out}", "", {"version":3,"sources":["/opt/build/repo/src/components/ProgressBar/ProgressBar.styles.scss"],"names":[],"mappings":"AAEA,kBAGE,YACA,AACA,sBACA,iBAAkB,CACnB,8BANC,kBACA,YACA,AACA,cACA,CAUD,AARA,YAGC,0CACA,AAEA,yCAAA,gCACA,CACD","file":"ProgressBar.styles.scss","sourcesContent":["@import '../../variables';\n\n.container {\n  border-radius: 2px;\n  height: 16px;\n  width: 300px;\n  max-width: 100%;\n  background-color: $gray-200;\n  position: relative;\n}\n\n.bar {\n  background-color: $primary-500;\n  height: 16px;\n  border-radius: 2px;\n  transition: width .2s ease-in-out;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "container__l2M6N",
	"bar": "bar__1qLtQ"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/ProgressBar/ProgressBar.styles.scss
// module id = qllV
// module chunks = 0